{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Transfero te operatori",
    "MESSAGE": "Më lidh me një operator"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Shkarkoni",
      "UPLOADING": "Po ngarkohet..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Dërgo"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Dërgo mesazh përsëri",
      "ERROR_MESSAGE": "Nuk mund të dërgohej, provo sërish"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Vlerësoni cilësinë e kësaj përgjigjeje"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Ju lutem prisni që të bashkohet agjenti"
  },
  "ROBOT_CHECK": {
    "TITLE": "Kontroll i shpejtë sigurie",
    "DESCRIPTION": "Ju lutem, plotësoni kontrollin më poshtë.",
    "VERIFYING": "Duke verifikuar…",
    "ERROR": "Kjo nuk funksionoi. Ju lutem provoni sërish.",
    "RETRY": "Provo sërish"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Ne jemi online",
    "OFFLINE": "Nuk jemi online për momentin",
    "ONLINE_WITH_BOT": "Ekipi dhe asistenti ynë AI janë online",
    "OFFLINE_WITH_BOT": "Asistenti ynë AI është këtu për t'ju ndihmuar",
    "BOT_ONLY_REPLY": "Përgjigjet menjëherë"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Zakonisht përgjigjet brenda pak minutash",
    "IN_A_FEW_HOURS": "Zakonisht përgjigjemi brenda disa orësh",
    "IN_A_DAY": "Zakonisht përgjigjemi brenda një dite",
    "BACK_IN": "Ne do të kthehemi serish online"
  },
  "DAY_NAMES": {
    "SUNDAY": "E diele",
    "MONDAY": "E Hënë",
    "TUESDAY": "E Martë",
    "WEDNESDAY": "E Mërkurë",
    "THURSDAY": "E Enjte",
    "FRIDAY": "E Premte",
    "SATURDAY": "E Shtunë"
  },
  "START_CONVERSATION": "Hap Bisedën",
  "END_CONVERSATION": "Mbyll bisedën",
  "CONTINUE_CONVERSATION": "Vazhdo bisedën",
  "YOU": "Ju",
  "START_NEW_CONVERSATION": "Hap një bisedë të re",
  "RESOLVE_LATER": "Këtë temë do ta zgjidhim me email/telefon. Tani dua të pyes për diçka tjetër.",
  "VIEW_UNREAD_MESSAGES": "Ju keni mesazhe të palexuara",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Shiko mesazhet e reja",
    "CLOSE_MESSAGES_BUTTON": "Mbylle",
    "COMPANY_FROM": "form",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Bisedo me ne"
  },
  "POWERED_BY": "Mundësuar nga {brandName}",
  "EMAIL_PLACEHOLDER": "Ju lutem shkruani email-in tuaj",
  "CHAT_PLACEHOLDER": "Shkruani mesazhin tuaj",
  "TODAY": "Sot",
  "YESTERDAY": "Dje",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Emri i plotë",
        "PLACEHOLDER": "Ju lutem shkruani emrin tuaj të plotë",
        "REQUIRED_ERROR": "Emri i plotë është i detyrueshëm"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Adresa e email-it",
        "PLACEHOLDER": "Ju lutem shkruani adresën tuaj të email-it",
        "REQUIRED_ERROR": "Adresa e email-it është e detyrueshme",
        "VALID_ERROR": "Ju lutem shkruani një adresë email-i të vlefshme"
      },
      "PHONE_NUMBER": {
        "LABEL": "Numri i telefonit",
        "PLACEHOLDER": "Ju lutem shkruani numrin tuaj të telefonit",
        "REQUIRED_ERROR": "Numri i telefonit është i detyrueshëm",
        "DIAL_CODE_VALID_ERROR": "Ju lutem zgjidhni kodin e vendit",
        "VALID_ERROR": "Ju lutem shkruani një numër telefoni të vlefshëm",
        "DROPDOWN_EMPTY": "Nuk u gjet asnjë rezultat",
        "DROPDOWN_SEARCH": "Kërko vendin"
      },
      "MESSAGE": {
        "LABEL": "Mesazhi",
        "PLACEHOLDER": "Ju lutem shkruani mesazhin tuaj",
        "ERROR": "Mesazhi është shumë i shkurtër"
      }
    },
    "CAMPAIGN_HEADER": "Ju lutem jepni emrin dhe email-in tuaj përpara se të filloni bisedën",
    "IS_REQUIRED": "është e detyrueshme",
    "REQUIRED": "E detyrueshme",
    "REGEX_ERROR": "Ju lutem jepni një vlerë të vlefshme"
  },
  "FILE_SIZE_LIMIT": "Skedari e kalon kufirin e bashkëngjitjes prej {MAXIMUM_FILE_UPLOAD_SIZE}",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Fushë e pavlefshme"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Kërko emoji",
    "NOT_FOUND": "Asnjë emoji nuk përputhet me kërkimin tuaj",
    "ARIA_LABEL": "Zgjedhësi i emojive"
  },
  "CSAT": {
    "TITLE": "Vlerësoni bisedën tuaj",
    "SUBMITTED_TITLE": "Faleminderit për dorëzimin e vlerësimit",
    "PLACEHOLDER": "Na tregoni më shumë..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Kërko transkriptin e bisedës",
    "SEND_EMAIL_SUCCESS": "Transkripti i bisedës u dërgua me sukses",
    "SEND_EMAIL_ERROR": "Ndodhi një gabim, ju lutem provoni sërish"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Artikujt Popullorë",
    "VIEW_ALL_ARTICLES": "Shiko të gjithë artikujt",
    "IFRAME_LOAD_ERROR": "Ndodhi një gabim gjatë ngarkimit të artikullit, ju lutem rifreskoni faqen dhe provoni sërish."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Hap",
      "BUY": "Bli"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Mesazh me foto"
    },
    "audio": {
      "CONTENT": "Mesazh audio"
    },
    "video": {
      "CONTENT": "Mesazh video"
    },
    "file": {
      "CONTENT": "Bashkëngjitje skedari"
    },
    "location": {
      "CONTENT": "Vendndodhja"
    },
    "fallback": {
      "CONTENT": "ka ndarë një URL"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Duke iu përgjigjur:"
  }
}
